import '../styles/mobileMenu.css'

const HamburgerMenu = ({ onClick, className, name}) => {
	return (
		<button
			name={name}
			onClick={onClick}
			className={className}
			aria-label="hamburger-menu"
		>
			<span className="bar"/>
			<span className="bar"/>
			<span className="bar"/>
		</button>
	);
}

export default HamburgerMenu;
